import { Component, OnInit } from '@angular/core';
import { Product } from '../product';
import { ProductService } from '../product.service';
import { CategoryService } from '../../categories/category.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { GlobalDataService } from '../../../../services/global-data.service';



export interface Pagination {
  current_page?: number;
  first_item?: number;
  first_page_url?: string;
  last_item?: number;
  last_page?: number;
  last_page_url?: string;
  next_page_url?: string;
  per_page?: number;
  prev_page_url?: string;
  total?: number;
}

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css'],
  providers: [
    ProductService,
    CategoryService
  ],
  preserveWhitespaces: false
})


export class ProductComponent implements OnInit {

  products: Product[];
  loading: boolean = true;
  pagination: Pagination;
  activePage:number=0;
  categoryFetch: any = [];
  categories: any = [];
  searchFilter: any = [];
  searchSku: string = "";
  searchName: string = "";
  searchCategory: string = "";


  constructor(
    private productService: ProductService,
    private categoryService: CategoryService,
    private activatedRoute: ActivatedRoute,
    private global: GlobalDataService,
    private router: Router) { }

  ngOnInit() {

    this.pagination = {
      current_page: 1,
      per_page: 1
    }

    this.activatedRoute.params.subscribe(params=>{this.pagination.current_page=params['page']});

    this.categoryService.getCategory(1).subscribe(response => {
      this.recarray(response['data'], 'children', this);
      this.categories = this.categoryFetch.map(function (value: any) {
        return { label: value.name, value: value.id };
      });
      this.loading = false;
    });

    this.getProduct(this.pagination.current_page,this.searchFilter);


  }

  getProduct(page: number,searchFilter: any) {
    this.loading = true;

    if(this.global.type=="product"){
      searchFilter= this.global.filter || this.searchFilter;
      this.searchFilter=searchFilter;
    }

    this.productService.getProductByFilter(searchFilter,page).subscribe(response => {
      this.pagination = response['pagination'] || this.pagination;
      this.activePage=this.pagination.first_item || 1;
      // this.searchFilter=[];
      this.products = response['data'].map(data => {
        let image = [];
        if (data['photos']) {
          for (let item in data['photos']) {
            image.push(data['photo_path'] + "/" + data['photos'][item]);
          }
        }
        return {
          id: data['id'],
          sku: data['sku'],
          name: data['name'],
          unit: data['unit']['name'],
          category: data['category']['name'],
          photos: image[0],
          available: data['available']
        }

      });
      this.loading = false;


    });
  }

  onPaginate(event) {
    this.pagination.current_page=event.page + 1;
    this.router.navigate(['/dashboard/product', {page: this.pagination.current_page}]);
    this.getProduct(this.pagination.current_page,this.searchFilter);
  }

  onSearch() {

    let attribute = "";
    let value = "";
    this.searchFilter=[];
    this.loading = true;
    if (this.searchSku) {
      this.searchFilter.push({ name: 'sku', value: this.searchSku })
    }
    if (this.searchName) {
      this.searchFilter.push({ name: 'name', value: this.searchName })
    }

    if (this.searchCategory) {
      this.searchFilter.push({ name: 'category_id', value: this.searchCategory })
    } 
    this.global.filter=this.searchFilter;
    this.global.type="product";
    this.router.navigate(['/dashboard/product', {page: 1}]);

    this.getProduct(1,this.searchFilter);

  }

  recarray(ar: any, searchfor: any, that: any) {
    ar.forEach(function (item: any, i: any, arr: any) {
      if (item instanceof Object) {
        if ("children" in item) {
          that.recarray(item['children'], searchfor, that)
        }
        that.categoryFetch.push(item);
      }
    });
  }

  create(): void {
    this.router.navigate(['/dashboard/product-crud']);
  }

  edit(id: any) {
    this.router.navigate(['/dashboard/product-crud', id]);
  }


}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/products/product/product.component.ts